
import TopNavBar from "app/layout/TopNavBar";
import SubscriptionService from "app/services/SubscriptionServices";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";


function SubscribersListView({ }) {
    const styles = {
        filterContainer: {
            marginBottom: 16,
            display: 'flex',
            gap: 12,
            alignItems: 'center',
            flexWrap: 'wrap',
        },
        filterInput: {
            padding: '6px 10px',
            border: '1px solid #bbb',
            borderRadius: 4,
            fontSize: '1em',
            minWidth: 120,
        },
        filterSelect: {
            padding: '6px 10px',
            border: '1px solid #bbb',
            borderRadius: 4,
            fontSize: '1em',
            minWidth: 120,
            background: '#fafafa',
        },
    };
    const cellStyle = { border: "1px solid #ddd", padding: "8px" };
    const thStyle = { ...cellStyle, fontWeight: "bold" };
    const [filters, setFilters] = useState({ user: "", first_name: "", is_active: "" });
    const [pageSize, setPageSize] = useState(5);
    const [page, setPage] = useState(1);
    const subscriptionService = SubscriptionService();
    const [subscriptions, setSubscriptions] = useState([]);
    const navigate = useNavigate();

    const fetchData = async () => {
        try {
            const subscriptions = await subscriptionService.getAllSubscriptions(filters.user, filters.is_active, pageSize);

            console.log('Fetched subscriptions:', subscriptions);

            setSubscriptions(subscriptions);

        } catch (error) {
            console.error('Error fetching subscriptions:', error);
            navigate("/my-files");
        }
    };

    useEffect(() => {


        fetchData();
    }, []);



    const pageSizes = [5, 20, 50, 100, 1000];

    const filteredSubscriptions = subscriptions.filter(pkg =>
        (filters.user === "" || pkg.user.includes(filters.user)) &&
        (filters.first_name === "" || pkg.first_name.includes(filters.first_name)) &&
        (filters.is_active === "" || pkg.is_active === (filters.is_active === "true"))
    );

    const paginated = filteredSubscriptions.slice((page - 1) * pageSize, page * pageSize);
    const totalPages = Math.ceil(filteredSubscriptions.length / pageSize);

    const [form, setForm] = useState({
        userEmail: '',
        packageId: '',
        paidAmount: '',
        tel: '',
        first_name: '',
        last_name: '',
        address: '',
        nic: '',
        note: ''
    });
    const [message, setMessage] = useState(null);
    const [messageType, setMessageType] = useState('');

    const handleFormChange = (e) => {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });
    };

    const handleSave = (e) => {
        e.preventDefault();
        // Simple validation
        if (!form.userEmail || !form.packageId || !form.paidAmount || !form.tel || !form.first_name || !form.last_name) {
            setMessage('Please fill all fields.');
            setMessageType('error');
            return;
        }
        if (isNaN(form.paidAmount) || Number(form.paidAmount) <= 0) {
            setMessage('Paid amount must be a positive number.');
            setMessageType('error');
            return;
        }
        subscriptionService.addSubscription({
            user: form.userEmail,
            package_id: form.packageId,
            price: form.paidAmount,
            tel: form.tel,
            first_name: form.first_name,
            last_name: form.last_name,
            note: form.note,
            address: form.address,
            nic: form.nic
        }).then(() => {
            setMessage(`Saved successfully! ${form.userEmail} subscribed to package ${form.packageId} with amount ${form.paidAmount}.`);
            setMessageType('success');
            setForm({ userEmail: '', packageId: '', paidAmount: '', tel: '', first_name: '', last_name: '', note: '' });
        }).catch((error) => {
            setMessage('Error saving subscription.');
            setMessageType('error');
        });
    }


    return (
        <DashboardLayout>
            <div>
                <TopNavBar />

                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'left' }}>
                    <h2>Subscribers</h2>
                    <button
                        type="button"
                        onClick={fetchData}
                        style={{ padding: '6px 16px', marginLeft: 12,    background: '#1976d2', color: '#fff', border: 'none', borderRadius: 4, fontWeight: 500, cursor: 'pointer' }}
                        title="Refresh List"
                    >
                        &#x21bb; Refresh
                    </button>
                </div>

              
                <h3>List</h3>
                <div style={styles.filterContainer}>
                    <input
                        placeholder="Email"
                        value={filters.user}
                        onChange={e => setFilters({ ...filters, user: e.target.value })}
                        style={styles.filterInput}
                    />
                    <input
                        placeholder="Name"
                        value={filters.first_name}
                        onChange={e => setFilters({ ...filters, first_name: e.target.value })}
                        style={styles.filterInput}
                    />
                    <select
                        value={filters.is_active}
                        onChange={e => setFilters({ ...filters, is_active: e.target.value })}
                        style={styles.filterSelect}
                    >
                        <option value="">All</option>
                        <option value="true">Active</option>
                        <option value="false">Inactive</option>
                    </select>
                    <select value={pageSize} onChange={e => { setPageSize(Number(e.target.value)); setPage(1); }} style={styles.filterSelect}>
                        {pageSizes.map(size => (
                            <option key={size} value={size}>{size} per page</option>
                        ))}
                    </select>
                </div>
                <table style={{ width: "100%", marginBottom: 16, borderCollapse: "collapse", fontSize: "0.95em" }}>
                    <thead>
                        <tr style={{ background: "#f5f5f5" }}>
                            <th style={thStyle}>Email</th>
                            <th style={thStyle}>Package ID</th>
                            <th style={thStyle}>First Name</th>
                            <th style={thStyle}>Last Name</th>
                            <th style={thStyle}>Telephone</th>
                            <th style={thStyle}>Address</th>
                            <th style={thStyle}>NIC</th>
                            <th style={thStyle}>Note</th>
                            <th style={thStyle}>Price</th>
                            <th style={thStyle}>Balance</th>
                            <th style={thStyle}>Status</th>
                            <th style={thStyle}>Start Date</th>
                            <th style={thStyle}>End Date</th>
                            <th style={thStyle}>Unit Price</th>
                            <th style={thStyle}>Units/Package</th>
                            <th style={thStyle}>Validity</th>
                        </tr>
                    </thead>
                    <tbody>
                        {paginated.map((pkg, idx) => (
                            <tr key={idx} style={{ background: idx % 2 === 0 ? "#fff" : "#f9f9f9" }}>
                                <td style={cellStyle}>{pkg.user}</td>
                                <td style={cellStyle}>{pkg.package_id}</td>
                                <td style={cellStyle}>{pkg.first_name}</td>
                                <td style={cellStyle}>{pkg.last_name}</td>
                                <td style={cellStyle}>{pkg.tel}</td>
                                <td style={cellStyle}>{pkg.address || '-'}</td>
                                <td style={cellStyle}>{pkg.nic || '-'}</td>
                                <td style={cellStyle}>{pkg.note}</td>
                                <td style={cellStyle}>{pkg.price / pkg.unit_price}</td>
                                <td style={cellStyle}>{pkg.balance / pkg.unit_price}</td>
                                <td style={cellStyle}>{pkg.status || '-'}</td>
                                <td style={cellStyle}>{pkg.start_date ? pkg.start_date.substring(0, 10) : '-'}</td>
                                <td style={cellStyle}>{pkg.end_date ? pkg.end_date.substring(0, 10) : '-'}</td>
                                <td style={cellStyle}>{pkg.unit_price}</td>
                                <td style={cellStyle}>{pkg.unites_per_package}</td>
                                <td style={cellStyle}>{pkg.validity}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <div>
                    Page: {page} / {totalPages}
                    <button disabled={page === 1} onClick={() => setPage(page - 1)}>Prev</button>
                    <button disabled={page === totalPages} onClick={() => setPage(page + 1)}>Next</button>
                </div>
                  {/* Data Entry Form */}
                <form onSubmit={handleSave} style={{ marginBottom: 24, border: '1px solid #eee', padding: 16, borderRadius: 8, maxWidth: 600 }}>
                    <h3>Add</h3>
                    <div style={{ display: 'flex', gap: 16 }}>
                        <div style={{ flex: 1 }}>
                            <div style={{ marginBottom: 8 }}>
                                <label htmlFor="userEmail" style={{ display: 'block', marginBottom: 2 }}>User Email</label>
                                <input
                                    type="email"
                                    name="userEmail"
                                    id="userEmail"
                                    placeholder="User Email"
                                    value={form.userEmail}
                                    onChange={handleFormChange}
                                    style={{ width: '100%', padding: 6 }}
                                />
                            </div>
                            <div style={{ marginBottom: 8 }}>
                                <label htmlFor="packageId" style={{ display: 'block', marginBottom: 2 }}>Package ID</label>
                                <input
                                    type="text"
                                    name="packageId"
                                    id="packageId"
                                    placeholder="Package ID"
                                    value={form.packageId}
                                    onChange={handleFormChange}
                                    style={{ width: '100%', padding: 6 }}
                                />
                            </div>
                            <div style={{ marginBottom: 8 }}>
                                <label htmlFor="paidAmount" style={{ display: 'block', marginBottom: 2 }}>Paid Amount</label>
                                <input
                                    type="number"
                                    name="paidAmount"
                                    id="paidAmount"
                                    placeholder="Paid Amount"
                                    value={form.paidAmount}
                                    onChange={handleFormChange}
                                    style={{ width: '100%', padding: 6 }}
                                />
                            </div>
                            <div style={{ marginBottom: 8 }}>
                                <label htmlFor="address" style={{ display: 'block', marginBottom: 2 }}>Address</label>
                                <input
                                    type="text"
                                    name="address"
                                    id="address"
                                    placeholder="Address"
                                    value={form.address}
                                    onChange={handleFormChange}
                                    style={{ width: '100%', padding: 6 }}
                                />
                            </div>
                        </div>
                        <div style={{ flex: 1 }}>
                            <div style={{ marginBottom: 8 }}>
                                <label htmlFor="tel" style={{ display: 'block', marginBottom: 2 }}>Telephone</label>
                                <input
                                    type="text"
                                    name="tel"
                                    id="tel"
                                    placeholder="Telephone"
                                    value={form.tel}
                                    onChange={handleFormChange}
                                    style={{ width: '100%', padding: 6 }}
                                />
                            </div>
                            <div style={{ marginBottom: 8 }}>
                                <label htmlFor="first_name" style={{ display: 'block', marginBottom: 2 }}>First Name</label>
                                <input
                                    type="text"
                                    name="first_name"
                                    id="first_name"
                                    placeholder="First Name"
                                    value={form.first_name}
                                    onChange={handleFormChange}
                                    style={{ width: '100%', padding: 6 }}
                                />
                            </div>
                            <div style={{ marginBottom: 8 }}>
                                <label htmlFor="last_name" style={{ display: 'block', marginBottom: 2 }}>Last Name</label>
                                <input
                                    type="text"
                                    name="last_name"
                                    id="last_name"
                                    placeholder="Last Name"
                                    value={form.last_name}
                                    onChange={handleFormChange}
                                    style={{ width: '100%', padding: 6 }}
                                />
                            </div>
                            <div style={{ marginBottom: 8 }}>
                                <label htmlFor="nic" style={{ display: 'block', marginBottom: 2 }}>NIC</label>
                                <input
                                    type="text"
                                    name="nic"
                                    id="nic"
                                    placeholder="NIC"
                                    value={form.nic}
                                    onChange={handleFormChange}
                                    style={{ width: '100%', padding: 6 }}
                                />
                            </div>
                        </div>
                    </div>
                    <div style={{ marginBottom: 8 }}>
                        <label htmlFor="note" style={{ display: 'block', marginBottom: 2 }}>Note</label>
                        <textarea
                            name="note"
                            id="note"
                            placeholder="Add a note..."
                            value={form.note}
                            onChange={handleFormChange}
                            style={{ width: '100%', padding: 6, minHeight: 60 }}
                        />
                    </div>
                    <button type="submit" style={{ padding: '8px 16px', background: '#1976d2', color: '#fff', border: 'none', borderRadius: 4 }}>Save</button>
                    {message && (
                        <div style={{ marginTop: 12, color: messageType === 'error' ? 'red' : 'green' }}>{message}</div>
                    )}
                </form>
            </div>
        </DashboardLayout>
    );
};



export default SubscribersListView;
